import { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { NotificationContext } from '../../contexts/NotificationContext';

export default function ScrollNotification() {
  const { notifications } = useContext(NotificationContext);
  const scrollNotifs = notifications.filter(n => 
    n.type === 'scroll' && n.status?.toLowerCase() === 'active'
  );

  if (scrollNotifs.length === 0) return null;

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'primary.main',
        color: 'white',
        py: 0.5,
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1000,
        borderRadius: 2,
        paddingLeft: 2,
        height: '30px',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          whiteSpace: 'nowrap',
          animation: 'marquee 10s linear infinite',
          '&:hover': {
            animationPlayState: 'paused'
          },
          '@keyframes marquee': {
            '0%': { transform: 'translateX(100%)' },
            '100%': { transform: 'translateX(-100%)' }
          }
        }}
      >
        {scrollNotifs.map((notif, index) => (
          <Typography
            key={notif.id}
            variant="subtitle2"
            sx={{ mx: 4, display: 'inline-block' }}
          >
            {notif.title}: {notif.message.replace(/<[^>]*>?/gm, '')}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
